import { Grid } from "@mui/material";
import Typography from "components/common/Typography";
import SelectedPlansList from "components/common/plans/SelectedPlansList";
import { tokens } from "styles/Tokens";

export default function SelectedList(props: any) {
  const { checkedList, setCheckedList, type } = props;
  return (
    <div>
      {checkedList?.length > 0 && (
        <Grid display="flex" justifyContent="flex-end" alignItems="center">
          <Typography variant="body2" showBold color={tokens.Text.General.Secondary}>
            {checkedList?.length} {type} selected
          </Typography>
          <SelectedPlansList
            options={checkedList}
            handleChange={(option: any, e) => setCheckedList(e, option)}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
          ></SelectedPlansList>
        </Grid>
      )}
    </div>
  );
}
